import { createSlice } from "@reduxjs/toolkit";
import { app_reset } from "../App/reducer";

const ITEMS_EMPTY_STATE = {
    items: [],
    isLoaded: false,
};

const initVideoDetailState = () => {
    return {
        relatedStories: ITEMS_EMPTY_STATE,
    };
};

const videoDetailSlice = createSlice({
    name: "videoDetail",
    initialState: initVideoDetailState(),
    reducers: {
        reset_video_detail: () => {
            return initVideoDetailState();
        },

        receive_related_stories: {
            reducer: (state, action) => {
                return {
                    ...state,
                    ...action.payload,
                };
            },
            prepare: (json) => {
                return {
                    payload: {
                        relatedStories: {
                            items: json,
                            isLoaded: true,
                        },
                    },
                };
            },
        },
    },
    extraReducers: (builder) => {
        builder.addCase(app_reset, () => {
            return initVideoDetailState();
        });
    },
});

export const { reset_video_detail, receive_related_stories } =
    videoDetailSlice.actions;

export default videoDetailSlice.reducer;
